var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-fade', _vm.collapsed && 'v-fade--collapsed', _vm.clickthrough && 'v-fade--clickthrough'],style:({ height: _vm.height })},[_vm._t("default"),(_vm.collapsed)?_c('div',{staticClass:"v-fade__fader"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }